import { render, staticRenderFns } from "./HistoricoEntradas.vue?vue&type=template&id=0f02b2be&scoped=true&"
import script from "./HistoricoEntradas.vue?vue&type=script&lang=js&"
export * from "./HistoricoEntradas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f02b2be",
  null
  
)

export default component.exports